<template>
  <div class="radio square-radio">
    <Extra v-for="(extra, index) in extras" :base="id" :form="extraForm[index]" :key="extra.id" :extra="formattedExtra(extra)"/>
  </div>
</template>

<script setup>

import {computed, onMounted, ref, watch} from "vue";
import Extra from "@/components/extra";
import {useFormatVariation} from "@/composables/useFormatVariation";

// eslint-disable-next-line no-undef
const props = defineProps({
  extras: {
    type: Array,
    default: () => {return []}
  },
  orderExtras: {
    type: Array,
    default: () => {return []}
  },
  id: {
    type: String,
    default: "1"
  },
  showPrice: {
    type: Boolean,
    default: true
  },
  modelValue: {

  }
})

const {$getVariationName} = useFormatVariation()
// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue'])
const extraForm = ref([])

onMounted(() => {
  initExtraForm()
})

const stringExtraForm = computed(() => JSON.stringify(extraForm.value))

watch(() => props.extras, () => {
  initExtraForm()
})

watch(() => props.showPrice, () => {
  initExtraForm()
})

watch(() => stringExtraForm.value, () => {
  setModelValue()
})

function initExtraForm(){
  if(props.extras?.length > 0){
    let data = []
    props.extras.map(extra => {
      let extraIndex = props.orderExtras?.findIndex(orderExtra => orderExtra.id == extra.id )
      if(props.orderExtras?.length > 0 && extraIndex != -1){
        data.push(props.orderExtras[extraIndex])
      }else{
        data.push({
          selected: false,
          id: extra.id,
          quantity: 0,
          price: props.id == "accompaniement" ? 0 : extra.price,
          name: extra?.name ? extra.name : $getVariationName(extra?.attributeAndCombination),
        })
      }
    })
    extraForm.value = data
  }
}

function setModelValue(){
  let selectedSupplements = []
  selectedSupplements = extraForm.value.filter(extra => extra.selected)
  emit('update:modelValue', selectedSupplements)
}

function formattedExtra(extra){
  return {
    id: extra.id,
    name: extra?.name ? extra.name : $getVariationName(extra.attributeAndCombination),
    price: props.showPrice ? extra.price : 0
  }
}



</script>

<style scoped>
.radio .checkmark{
  border: 1px solid var(--secondary);
}
.radio .radio-label input:checked ~ .checkmark{
  background-color: var(--secondary);
  border: 1px solid var(--secondary);
}
.radio.square-radio .radio-label .checkmark{
  border-radius: 5px;
}
.radio.square-radio .radio-label .checkmark:after{
  border-radius: 5px;
}

.company-detail .item-inner li .reviews-info i{
  color: var(--secondary);
}

.radio .radio-label .checkmark:after{
  background: var(--secondary);
}

.radio .checkmark{
  border: 1px solid var(--secondary);
}
.radio{
  padding-top: 15px;
  text-align: initial;
}

</style>